import script from "./DBstatusview.vue?vue&type=script&setup=true&lang=ts"
export * from "./DBstatusview.vue?vue&type=script&setup=true&lang=ts"

import "./DBstatusview.vue?vue&type=style&index=0&id=6373e38e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9243d0548d070ce3cb63e50486d60596/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6373e38e"]])

export default __exports__